{
    "RunondayMonthLabel": "Uitvoeren op dag (maand):",
    "RunondayWeekLabel": "Uitvoeren op dag (week):",
    "RunondaysLabel": "Automatisch wisselen van rapportweergave",
    "RunbetweenhoursStartLabel": "Loop tussen uren:",
    "RunbetweenhoursEndLabel": "En:",
    "RunbetweenhoursNote": "(Inclusief op het hele einduur)",
    "RunatminuteHourLabel": "Uitvoeren op minuut (uur):",
    "RunatminuteHourNote": "Verleden elk uur (bij benadering)",
    "RunondateLabel": "Rapport uitvoeren op datum:",
    "RunattimeLabel": "Uitvoeren op tijd (ongeveer):",
    "TimeOptions_SectionHeader": "Afdrukuitvoeropties",
    "NAME": "TimeOptions"
}